import React from 'react';
import './summary.css'; // You can style your component separately

const Summary = () => {
  return (
    <div className="summary-container">
      <h3>Resumen de Operaciones</h3>
      <table className="summary-table">
        <tbody>
          <tr>
            <td>Ventas Netas...</td>
            <td>$389.38</td>
          </tr>
          <tr>
            <td>Iva(Débito Fiscal)</td>
            <td>$50.62</td>
          </tr>
          <tr>
            <td>Iva Retenido</td>
            <td>$0.00</td>
          </tr>
          <tr className="total-row">
            <td>Total Ventas...</td>
            <td>$440.00</td>
          </tr>
          <tr>
            <td>Ventas Exentas</td>
            <td>$0.00</td>
          </tr>
          <tr>
            <td>Ventas al Exterior</td>
            <td>$0.00</td>
          </tr>
          <tr className="total-row">
            <td>Total Ventas</td>
            <td>$0.00</td>
          </tr>
          <tr className="grand-total">
            <td>Total Ventas</td>
            <td>$440.00</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default Summary;